import type { FaireProductEntity } from "../../entity_types/product";

export const p_a4zedcqhd7: FaireProductEntity = {
  token: "p_a4zedcqhd7",
  type: "product",
  name: "Safari Animals Baby Romper (Organic Jersey)",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/5cb6d19daa53cdc8fd2290f11c8254eb9fc1a90c6d749c8776dc35e7ec695681.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/58d7458088151979c5eedd23dc6e0b9c0a917cd7598e86d9a569790480813bb4.png",
    "https://cdn.faire.com/fastly/390b3790cd6ee1aac5ece62ecc57961b5d59c74cafb490f7ab40acd43b689242.png",
    "https://cdn.faire.com/fastly/e14aa12b37f1b09e058d0aa8fd70b41b6037353e51c393282e4c2448162b67ac.png",
  ],
  priceDollars: 22,
  description:
    "Ultra-soft, lightweight, breathable, cozy, and comfy organic baby romper.\n\n- Digitally printed for extra softness.\n- Chemical-free & non-toxic formulation, eco-friendly & sustainable.\n- Machine wash and dry, durable and long-lasting.\n- Ethically produced in India from small farmer-sourced organic cotton.\n- 95% organic cotton jersey / 5% lycra stretch formulation for extra comfort.\n\nViverano, an American brand, was founded in 2013 with the simple idea of producing eco-friendly, pure and organic baby clothes. Viverano baby clothing is known for its soft hand feel and high quality. Pamper your precious babies with our non-toxic, lightweight, all-season, natural baby outfits.\n\nExperience 'Organic Comfort' by Viverano, a family-owned small business.",
  tags: [],
  msrpDollars: 44,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:33.544Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
